import React from "react";
import { Typography } from "@mui/material";

const Home = () => {
    return <Typography variant="h4">Quiz</Typography>;
};

export default Home;
